import React, { Component, useState, Fragment } from "react";
import { Modal, Button, Form, Table } from "react-bootstrap";
import 'bootstrap/dist/css/bootstrap.min.css';
import Switch from 'react-bootstrap/Switch';
import InputGroup from 'react-bootstrap/InputGroup';
import Spreadsheet, { createEmptyMatrix } from "react-spreadsheet";
import '../css/paste.css';

import {addPartsFunction} from './PartsFunction';
import {addCmListFunction} from './CmListFunction';
import ExcelCsv from "./ExcelCsv";



export default class PasteAdmin extends Component{
  
  constructor(){
    super();

    let default_tabel_data = [[{ value: "KEY" }]];
    let i =0;
    while(i<50){
      default_tabel_data.push([{ value: "" }]);
      i++;
    };





    this.state={
      isOpen: false,
      table_data_default: default_tabel_data,
      select_array:['ステータスの変更:完了にする'],
      select_label:'',
      sheet_submit:false,
      re_table_data_array:[]
    }
  }

  
  componentDidMount () {
  }
  
  openModal = () => {
    this.setState({ isOpen: true });
  }

  closeModal = () => {
    this.setState({ isOpen: false }); 
    this.setState({select_label:''});
  }
  


  

  
    
  render(){

    var handleChangeSelect = async (e) => {
      console.dir(e.target);

      this.setState({select_label:e.target.value});
      e.preventDefault();
    }




    var submit_add_table = async (e) =>{
      this.setState({sheet_submit:true});
      //console.dir(e.target);
      let tr_elems = document.getElementsByClassName('paste-table-admin')[0].childNodes[0].childNodes[1].childNodes;
      console.dir(tr_elems);

      let __data = this.props.data.dataArray;
			let __data_fix = this.props.data.cm_datas; //順番変わってる...
      let key_array = [];

      if(this.state.select_label==='ステータスの変更:完了にする'){
        let res = addPartsFunction.changeDataStatus(tr_elems, '完了', __data, __data_fix);
        __data = res[0];
        __data_fix = res[1];
        key_array = res[2];

        if(key_array.length>0){
          addPartsFunction.postChangeDataStatus(key_array, this.props.data.auth_obj, '完了');
        }
        

      }



			this.props.getCmDatas(__data_fix);
			this.props.getDataArray(__data);

			let re_hattyuu_howmany = 0;
			re_hattyuu_howmany = addCmListFunction.calcHikiateHowmany(__data);
			//this.props.keepList('search_submit', re_hattyuu_howmany, this.props.data.table_tonya_label);//hattyuu_howmanyベース

      if(this.props.data.search_array!==undefined){
        if(this.props.data.search_array.length===0){
          this.props.changeSelectTonyaHattyuu(re_hattyuu_howmany, this.props.data.table_tonya_label, 'paste_excel');//hattyuu_howmanyベース
        }else{
          this.props.keepList('search_submit', re_hattyuu_howmany, this.props.data.table_tonya_label);//hattyuu_howmanyベース
        }
      }else{
				this.props.keepList('search_submit', re_hattyuu_howmany, this.props.data.table_tonya_label);//hattyuu_howmanyベース
			}
      

      this.setState({sheet_submit:false});


          
    }





    let sheet_content_class = '';
    let sheet_class = '';
    let button_class = '';
    let isit_disable = true;
    let loadding_icon = false;

    if(this.state.isOpen){
      sheet_content_class = 'paste-elem-admin';
      sheet_class = 'admin_sheet_modal';
      button_class = 'btn btn-sm btn-info a-small sheet_close_button';
    }else{
      sheet_content_class = 'paste-elem-admin paste-elem-admin_not_show';
      sheet_class = 'admin_sheet_modal_not_show';
      button_class = 'btn btn-sm btn-info  a-small';

    }



    if(this.state.select_label!==''){
      isit_disable = false;
    }else{
      isit_disable = true;
    }

    if(this.state.sheet_submit){
      loadding_icon = true;
    }

    let excel_style = 'paste-table-admin';

    let table_data = this.state.table_data_default;;

    return (


        
      <div className={sheet_content_class}>
        <div className={button_class} >
          {this.state.isOpen ? <div onClick={this.closeModal}>閉じる</div> : <div onClick={this.openModal}>管理的変更</div>}
        </div>
          
          
        <div className={sheet_class}>
          <div className="choose_sheet_layout my-2 d-flex flex-row">
            <select className="custom-select text-center" value={this.state.select_label} onChange={handleChangeSelect}>
							{this.state.select_array.map((menu, index)=>{
          			return(
									<option key={"s_"+String(index)} value={menu}>{menu}</option>
								)
							})}
								<option defaultValue="" value="">選択ください</option>
          	</select> 

            {isit_disable ? 
              <>
                <button className="btn btn-sm btn-primary  a-small sheet_submit_button" disabled>反映する</button>
              </> 
              : 
              <>
                <button className="btn btn-sm btn-primary  a-small sheet_submit_button" onClick={(e)=>{submit_add_table(e)}} >反映する</button>
              </>}
            
          </div>

          <Spreadsheet 
            data={table_data} 
            className={excel_style}
          />

        </div>
        
        
      </div>
    );
  }
}
  
  

	//{...this.props}